import { useQuery, UseQueryResult } from "react-query";
import { getLiquidityBalance } from "../../../api/merchant";
import { useReduxContext } from "./reduxContext";
import { LiquidityBalance } from "./config";

const useLiquidityBalanceQuery = (): UseQueryResult<LiquidityBalance> => {
  const [state] = useReduxContext();
  return useQuery({
    queryKey: ["getLiquidityBalance", state.createRequest],
    enabled: state.createRequest !== undefined,
    queryFn: () =>
      getLiquidityBalance({
        pathId:
          state.createRequest?.cross_merchant_transfer_exchange_rate.path_id ??
          "",
      }),
  });
};
export default useLiquidityBalanceQuery;
